import { ValidationErrorResponseSchema } from '@mntn/api-contracts/_shared/error-responses'
import { ErrorResponseSchema } from '@mntn/result'
import { initContract } from '@ts-rest/core'
import {
  GetMeRequestSchema,
  GetMeResponseSchema,
  PostSessionChangedBodySchema,
  PostSessionChangedRequestSchema,
  PostSessionChangedResponseSchema,
} from './schemas.ts'

const c = initContract()

const BASE = '/flight-deck/v1/me'

export const meContract = c.router(
  {
    get: c.query({
      method: 'GET',
      path: BASE,
      description: 'Get the current session for flight deck',
      request: GetMeRequestSchema,
      responses: {
        200: GetMeResponseSchema,
      },
    }),
    sessionChanged: c.mutation({
      method: 'POST',
      path: `${BASE}/session-changed`,
      description:
        'Signals that the caller switched advertisers. Fans out to the user’s other connected sockets so each origin (eg. premier, select-ui, flight-deck) can fire its reload modal.',
      body: PostSessionChangedBodySchema,
      request: PostSessionChangedRequestSchema,
      responses: {
        200: PostSessionChangedResponseSchema,
      },
    }),
  },
  {
    strictStatusCodes: true,
    commonResponses: {
      400: ValidationErrorResponseSchema,
      401: ErrorResponseSchema,
      403: ErrorResponseSchema,
    },
    metadata: { tags: ['Flight Deck'] },
  },
)

export type MeContract = typeof meContract
